import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable()
export class ClientInterceptor implements HttpInterceptor {
  private configurationService = inject(ConfigurationService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const client = this.configurationService.clientName;

    req = req.clone({
      setHeaders: {
        client,
        'gs-pv-env': this.configurationService.provenueEnvironment,
      },
    });

    return next.handle(req);
  }
}
